import { Component, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort, SortDirection } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { GlobalConstants } from 'src/app/common/globals';
import {
  DataGridSearchPagedModel,
  DataGridSettingModel,
  DataGridStateModel, DataGridTabModel,
  PagerModel,
  SearchParametersDto
} from 'src/app/models/data-grid.model';
import { StorageService } from 'src/app/services/storage.service';
import { DeleteComponent } from '../delete-component/delete-component.component';
import { MatRadioChange } from '@angular/material/radio';
import { GenericModalComponent } from 'src/app/components/modals/generic-modal/generic-modal.component';
import { ChangePasswordForUserRequestData, SecurityResultStatus } from 'src/app/clients/system-api/SystemApiClient';
import { UserService } from 'src/app/services/user.service';
import { SnackBarService } from 'src/app/services/snack-bar.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-data-grid',
  templateUrl: './data-grid.component.html',
  styleUrls: ['./data-grid.component.scss']
})
export class DataGridComponent implements OnInit {
  @ViewChild(MatPaginator, { static: true }) paginator!: MatPaginator;

  @ViewChild(GenericModalComponent) genericModalComponent!: GenericModalComponent;
  @ViewChild(MatSort, { static: true }) sort!: MatSort;
  @Input() dataGridSettings = {} as DataGridSettingModel;
  @Input() idParam = {} as Number;
  @Input() booleanParam = {} as boolean;

  @Input() set refreshDatGrid(val: any) {
    if (val) {
      this.getData();
    }
  }

  dataGridSettingsValid!: boolean;
  searchModel = {} as DataGridSearchPagedModel;
  sortDataBy: string | undefined;
  searchTitle: string | undefined;
  totalDataItems: number | undefined;
  dataService: any = {};
  getAllServiceName!: string;
  generateReportServiceName!: string;
  updateServiceName: string | undefined;
  createServiceName: string | undefined;
  deleteServiceName: string | undefined;
  searchServiceName: string | undefined;
  searchColumnName: string | undefined;
  pageEvent: PageEvent | undefined;
  pageSize!: number;
  searchDataActive = false;
  gridState = {} as DataGridStateModel;
  pageSizes = [5, 10, 20, 50, 100];
  matDataSource = new MatTableDataSource<any>();
  data: any;
  displayedColumns: any[] = [];
  getAllServiceNameArguments = {} as PagerModel;
  skipCount = 0;
  mediaUrl!: string;
  screenWidth: any;
  tab: number = 1

  //Popups
  addServicePopupState: boolean = false;
  editServicePopupState: boolean = false;
  userAddPopupState: boolean = false;
  editUserPopupState: boolean = false;
  changePasswordPopupState: boolean = false;

  userId?: number;
  serviceId?: number;

  isFieldRequired: boolean = true;
  confirmPassword: string | undefined;

  changePasswordForm: FormGroup | undefined;
  changePasswordForUserRequestData = new ChangePasswordForUserRequestData();
  searchParam = {} as SearchParametersDto;

  constructor(private storageService: StorageService,
    private router: Router,
    private userService: UserService,
    private _snackBarService: SnackBarService,
    private _formBuilder: FormBuilder,
    public dialog: MatDialog) {
  }

  ngOnInit(): void {
    this.screenWidth = window.innerWidth;
    if (this.dataGridSettings.hasTabs)
      this.tab = this.dataGridSettings.selectedTab!

    this.checkDataGridSettingValidity().then((valid) => {
      if (valid) {
        this.resetPager();
      }
    });

    this.changePasswordForm = this._formBuilder.group({
      newPassword: ['', Validators.required, Validators.minLength(6)],
      confirmPassword: ['', Validators.required, Validators.minLength(6)],
    })
  }

  ngAfterViewInit() {
    this.checkDataGridSettingValidity().then((valid) => {
      if (valid) {
        this.initDataGrid();
      }
    });
  }

  @HostListener('window:resize', ['$event'])
  onWindowResize() {
    this.screenWidth = window.innerWidth;
  }

  public toggleAddServicePopup(state?: boolean) {
    this.addServicePopupState = false;
    this.addServicePopupState = state ?? !this.addServicePopupState;
  }

  public toggleAddUserPopup(state?: boolean) {
    this.userAddPopupState = false;
    this.userAddPopupState = state ?? !this.userAddPopupState;
  }


  public toggleEditUserPopup(state?: boolean) {
    this.editUserPopupState = false;
    this.editUserPopupState = state ?? !this.editUserPopupState;
  }

  public toggleEditServicePopup(state?: boolean) {
    this.editServicePopupState = false;
    this.editServicePopupState = state ?? !this.editServicePopupState;
  }

  public toggleChangePasswordPopup(state?: boolean) {
    this.changePasswordPopupState = false;
    this.changePasswordPopupState = state ?? !this.changePasswordPopupState;
  }

  changePassword(id: number) {
    this.toggleChangePasswordPopup();
    this.userId = id;
  }
  addComponent() {
    if (this.dataGridSettings.addComponent == 'ServiceAddComponent') {
      this.toggleAddServicePopup();
    }
    else if (this.dataGridSettings.addComponent == 'UserAddComponent') {
      this.toggleAddUserPopup();
    }
  }

  //Change password from admin
  public async changePasswordForUser(): Promise<void> {
    try {
      const data = await this.userService.changePasswordForUser(this.userId, this.changePasswordForUserRequestData).toPromise();
      if (data === SecurityResultStatus.Success) {
        this._snackBarService.callSnackBar(data, 'Change Password');
        this.closePopup();
      } else {
        throw new Error();
      }
    } catch (error) {
      this._snackBarService.callSnackBar('Error');
    }
  }

  public savePassword(): void {
    if (this.changePasswordForUserRequestData.newPassword == this.confirmPassword) {
      this.changePasswordForUser();
    }
    else {
      this._snackBarService.callSnackBar('ConfirmPasswordError');
    }
  }

  closePopup() {
    this.genericModalComponent.handleClose(true);
    this.userAddPopupState = false;
    this.editUserPopupState = false;
    this.addServicePopupState = false;
    this.editServicePopupState = false;
    this.changePasswordPopupState = false;
    this.getData();
  }

  editComponent(id: number) {
    if (this.dataGridSettings.editComponent == 'ServiceEditComponent') {
      this.toggleEditServicePopup();
      this.serviceId = id;
    }
    else if (this.dataGridSettings.editComponent == 'UserEditComponent') {
      this.toggleEditUserPopup();
      this.userId = id;
    }
  }

  radioChange(event: MatRadioChange) {
    if (event.value == 1) {
      this.dataGridSettings.searchColumns = ["DateTo", "DateFrom"];
      this.cancelSearchData()
    } else if (event.value == 2) {
      this.dataGridSettings.searchColumns = ["SelectionId", "SecondSelectionId"];
      this.cancelSearchData()
    } else if (event.value == 3) {
      this.dataGridSettings.searchColumns = ["SelectionId"];
      this.cancelSearchData()
    }
  }

  generateReport() {
    let buildServiceCall: any;

    this.generateReportServiceName = this.dataGridSettings.generateReportServiceName == null ? 'getAll' : this.dataGridSettings.generateReportServiceName;

    this.getAllServiceNameArguments.SearchParam = this.searchModel.SearchParam!
    this.getAllServiceNameArguments.SelectionId = this.searchModel.SelectionId!
    this.getAllServiceNameArguments.SecondSelectionId = this.searchModel.SecondSelectionId!
    this.getAllServiceNameArguments.FromDate = this.searchModel.FromDate!
    this.getAllServiceNameArguments.ToDate = this.searchModel.ToDate!
    buildServiceCall = this.dataService[this.generateReportServiceName](this.getAllServiceNameArguments);

    buildServiceCall.subscribe((data: any) => {
      this.data = data;
      var fileName = this.dataGridSettings.generatedReportFileName
    });
  }

  deleteComponent(id: number) {
    const dialogref = this.dialog.open(DeleteComponent, {
      width: "400%",
      maxWidth: "400px",
      data: {
        id: id,
        serviceName: this.dataGridSettings.getAllServiceName
      }
    });

    dialogref.afterClosed().subscribe((result) => {
      if (result == "submit") {
        this.getData();
      }
    })
  }

  checkDataGridSettingValidity(): Promise<boolean> {
    return new Promise((resolve) => {
      if (this.dataGridSettings.enableSearch && !this.dataGridSettings.searchColumns) {
        this.dataGridSettingsValid = false;
        resolve(false);
      } else {
        this.dataGridSettingsValid = true;
        resolve(true);
      }
    })
  }

  async resetPager() {
    if (!this.dataGridSettings.defaultPageSize) {
      this.dataGridSettings.defaultPageSize = '5';
    }

    this.pageSize = parseInt(this.dataGridSettings.defaultPageSize, 10);

    if (this.dataGridSettings.sortBy) {
      this.sortDataBy = this.dataGridSettings.sortBy;
    } else {
      this.sortDataBy = 'Id ASC';
    }

    this.skipCount = 0;

    this.searchModel.MaxResultCount = this.pageSize;
    this.searchModel.SkipCount = this.skipCount;
    this.searchModel.Sorting = this.sortDataBy;

    this.getAllServiceNameArguments.MaxResultCount = this.pageSize;
    this.getAllServiceNameArguments.SkipCount = this.skipCount;
    this.getAllServiceNameArguments.Sorting = this.sortDataBy;

    if (this.paginator) {

      this.paginator.pageSize = this.pageSize;
      this.paginator.firstPage();
    }
  }

  async initPager(e: PageEvent) {
    if (e) {
      if (e.pageSize !== this.pageSize) {
        e.pageIndex = 0;
      }
      this.pageSize = e.pageSize;
      this.skipCount = this.pageSize * e.pageIndex;

      this.getAllServiceNameArguments.MaxResultCount = this.pageSize;
      this.getAllServiceNameArguments.SkipCount = this.skipCount;
      this.getAllServiceNameArguments.Sorting = this.sortDataBy!;

      this.searchModel.MaxResultCount = this.pageSize;
      this.searchModel.SkipCount = this.skipCount;
      this.searchModel.Sorting = this.sortDataBy!;

      this.gridState.CurrentPage = e.pageIndex;
      this.gridState.PageSize = e.pageSize;
      this.gridState.SortBy = this.sortDataBy;
      this.saveGridState();

      this.getData();
    }
  }

  async initDataGrid() {
    this.dataService = this.dataGridSettings.dataService;
    this.getAllServiceName = this.dataGridSettings.getAllServiceName == null ? 'getAll' : this.dataGridSettings.getAllServiceName;

    if (this.dataGridSettings.dataGridID) {
      const gs = await this.getDataGridState(this.dataGridSettings.dataGridID);
      if (gs) {
        if (Object.keys(gs).length > 0) {

          this.setDataGridState().then(() => {
            this.getData();
          });
        }
      } else {
        this.getData();
      }
    } else {
      this.getData();
    }

    for (const item of this.dataGridSettings.columns) {
      this.displayedColumns.push(item.DbName);
    }
  }

  async getDataGridState(id: string) {
    return this.storageService.getValue(GlobalConstants.DataGridStateLsKey).subscribe((res: DataGridStateModel[]) => {

      if (res && Object.keys(res).length > 0) {
        const getGridState = res.find(x => x.ID === id);

        if (getGridState) {
          this.gridState = getGridState;
          return getGridState;
        } else {
          return false;
        }
      } else {
        return false;
      }

    });
  }

  async setDataGridState() {
    this.pageSize = this.gridState.PageSize;
    this.sortDataBy = this.gridState.SortBy;

    this.paginator.pageIndex = this.gridState.CurrentPage;
    this.paginator.pageSize = this.gridState.PageSize;

    this.sort.direction = this.gridState.SortBy!.split(' ')[1].toLowerCase() as SortDirection;
    this.sort.active = this.gridState.SortBy!.split(' ')[0];
    this.skipCount = this.pageSize * this.gridState.CurrentPage;

    this.searchModel.MaxResultCount = this.pageSize;
    this.searchModel.SkipCount = this.skipCount;
    this.searchModel.Sorting = this.sortDataBy as string;
    this.searchModel.FromDate = this.gridState.SearchFromDate ? this.gridState.SearchFromDate : null;
    this.searchModel.ToDate = this.gridState.SearchToDate ? this.gridState.SearchToDate : null;
    this.searchModel.SearchParam = this.gridState.SearchParam;

    this.searchDataActive = this.gridState.SearchActive;
    this.getAllServiceNameArguments.MaxResultCount = this.pageSize;
    this.getAllServiceNameArguments.SkipCount = this.skipCount;
    this.getAllServiceNameArguments.Sorting = this.sortDataBy as string;

    return true;
  }

  async getData() {
    if (this.dataGridSettings.isDataPaged) {
      this.getPagedData();
    } else {
      this.getNonPagedData();
    }
  }

  async getNonPagedData() {
    let buildServiceCall: any;

    if (this.dataGridSettings.getAllServicePrependArgument && !this.dataGridSettings.getAllServiceAppendArgument) {
      buildServiceCall = this.dataService[this.getAllServiceName](this.dataGridSettings.getAllServicePrependArgument);
    }

    if (!this.dataGridSettings.getAllServicePrependArgument && this.dataGridSettings.getAllServiceAppendArgument) {
      buildServiceCall = this.dataService[this.getAllServiceName](this.dataGridSettings.getAllServiceAppendArgument);
    }

    if (this.dataGridSettings.getAllServicePrependArgument && this.dataGridSettings.getAllServiceAppendArgument) {
      buildServiceCall = this.dataService[this.getAllServiceName](
        this.dataGridSettings.getAllServicePrependArgument,
        this.dataGridSettings.getAllServiceAppendArgument);
    }

    if (!this.dataGridSettings.getAllServicePrependArgument && !this.dataGridSettings.getAllServiceAppendArgument) {
      buildServiceCall = this.dataService[this.getAllServiceName]();
    }

    buildServiceCall.subscribe((data: any) => {
      this.data = data;
      this.matDataSource = data.content;
      this.totalDataItems = data.length;

    });
  }

  async getPagedData() {
    let buildServiceCall: any;

    if (this.dataGridSettings.hasIdParam) {
      this.getAllServiceNameArguments.SearchParam = this.searchModel.SearchParam!
      this.getAllServiceNameArguments.SelectionId = this.searchModel.SelectionId!
      this.getAllServiceNameArguments.SecondSelectionId = this.searchModel.SecondSelectionId!
      buildServiceCall = this.dataService[this.getAllServiceName](this.idParam, this.getAllServiceNameArguments);
    } else if (this.dataGridSettings.hasGlobalSearchBar == true) {
      this.getAllServiceNameArguments.SearchParam = this.searchModel.SearchParam!
      buildServiceCall = this.dataService[this.getAllServiceName](this.booleanParam, this.getAllServiceNameArguments);

    } else if (this.dataGridSettings.hasBooleanParam == true) {
      buildServiceCall = this.dataService[this.getAllServiceName](this.booleanParam, this.getAllServiceNameArguments);
    } else {

      if (this.dataGridSettings.getAllServicePrependArgument && !this.dataGridSettings.getAllServiceAppendArgument) {
        buildServiceCall = this.dataService[this.getAllServiceName](
          this.dataGridSettings.getAllServicePrependArgument,
          this.getAllServiceNameArguments);
      }

      if (!this.dataGridSettings.getAllServicePrependArgument && this.dataGridSettings.getAllServiceAppendArgument) {
        buildServiceCall = this.dataService[this.getAllServiceName](
          this.getAllServiceNameArguments,
          this.dataGridSettings.getAllServiceAppendArgument);
      }

      if (this.dataGridSettings.getAllServicePrependArgument && this.dataGridSettings.getAllServiceAppendArgument) {
        buildServiceCall = this.dataService[this.getAllServiceName](
          this.dataGridSettings.getAllServicePrependArgument,
          this.getAllServiceNameArguments,
          this.dataGridSettings.getAllServiceAppendArgument);
      }

      if (!this.dataGridSettings.getAllServicePrependArgument && !this.dataGridSettings.getAllServiceAppendArgument) {
        this.getAllServiceNameArguments.SearchParam = this.searchModel.SearchParam!
        this.getAllServiceNameArguments.SelectionId = this.searchModel.SelectionId!
        this.getAllServiceNameArguments.SecondSelectionId = this.searchModel.SecondSelectionId!
        this.getAllServiceNameArguments.FromDate = this.searchModel.FromDate!
        this.getAllServiceNameArguments.ToDate = this.searchModel.ToDate!
        buildServiceCall = this.dataService[this.getAllServiceName](this.getAllServiceNameArguments);
      }
    }

    buildServiceCall.subscribe((data: any) => {

      this.data = data;
      this.matDataSource = data.content.items;
      this.totalDataItems = data.content.totalCount;

    });
  }

  async sortData(sort: Sort) {
    if (!this.dataGridSettings.isDataPaged) {

      const data = this.data.slice();

      if (!sort.active || sort.direction === '') {
        this.matDataSource = data;
        return;
      }

      this.matDataSource = data.sort((a: any, b: any) => {
        const isAsc = sort.direction === 'asc';
        return compare(a[sort.active], b[sort.active], isAsc);
      });

    } else {
      if (!sort.active || sort.direction === '') {
        return;
      } else {
        this.sortDataBy = sort.active + ' ' + sort.direction.toUpperCase();
        this.gridState.SortBy = this.sortDataBy;
        this.getAllServiceNameArguments.Sorting = this.sortDataBy;
        this.searchModel.Sorting = this.sortDataBy;
        this.saveGridState();
        this.getPagedData();
      }
    }
  }

  async saveGridState() {
    this.gridState.CurrentPage = this.paginator.pageIndex;
    this.gridState.PageSize = this.paginator.pageSize;
    this.gridState.SortBy = this.sortDataBy;

    this.gridState.ID = this.dataGridSettings.dataGridID;
    this.gridState.SearchActive = this.searchDataActive;
    this.gridState.SearchFromDate = this.searchModel.FromDate ? this.searchModel.FromDate : null;
    this.gridState.SearchToDate = this.searchModel.ToDate ? this.searchModel.ToDate : null;
    this.gridState.SearchParam = this.searchModel.SearchParam;


    this.storageService.getValue(GlobalConstants.DataGridStateLsKey).subscribe((res: DataGridStateModel[]) => {

      if (res && Object.keys(res).length > 0) {
        const getGridState = res.find(x => x.ID === this.gridState.ID);

        if (getGridState) {
          const states = res.filter(x => x.ID !== this.gridState.ID);
          states.push(this.gridState);
          this.storageService.setValue(GlobalConstants.DataGridStateLsKey, states);
        } else {
          res.push(this.gridState);
          this.storageService.setValue(GlobalConstants.DataGridStateLsKey, res);
        }

      } else {
        const states = [] as DataGridStateModel[];
        states.push(this.gridState);
        this.storageService.setValue(GlobalConstants.DataGridStateLsKey, states);
      }

    });
  }

  fixNestedDbName(dataItem: any, dbName: any) {
    for (const prop of dbName.split('.')) {
      dataItem = dataItem[prop];
      if (dataItem !== null && typeof dataItem !== 'object') {
        return dataItem;
      }
    }
  }

  onClick(ID: number) {
    if (this.dataGridSettings.viewUrl) {
      var url = this.dataGridSettings.viewUrl + ID;
      this.router.navigateByUrl(url);
    }

  }

  async edit(item: any) {
    // this.dataService[this.](item).subscribe((data: any) => {
    //   this.getData();
    // }, (err: any) => {
    //   this.getData();
    // });

    //TODO
  }

  async searchData() {
    this.searchDataActive = true;
    this.saveGridState();
    if (this.paginator) {
      if (this.paginator.pageIndex !== 0) {
        this.resetPager();
      } else {
        this.getData();
      }
    } else {
      this.getData();
    }
  }

  async cancelSearchData() {
    this.searchDataActive = false;

    this.searchModel.ToDate = null;
    this.searchModel.FromDate = null;
    this.searchModel.SearchParam = null;
    this.searchModel.SelectionId = null;
    this.searchModel.SecondSelectionId = null;

    this.saveGridState();

    if (this.paginator) {

      if (this.paginator.pageIndex !== 0) {
        this.resetPager();
      } else {
        this.getData();
      }
    } else {
      this.getData();
    }
  }

  async getDatGridState(id: any) {
    return this.storageService.getValue(GlobalConstants.DataGridStateLsKey).subscribe((res: DataGridStateModel[]) => {

      if (res && Object.keys(res).length > 0) {
        const getGridState = res.find(x => x.ID === id);

        if (getGridState) {
          this.gridState = getGridState;
          return getGridState;
        } else {
          return;
        }

      } else {
        return;
      }

    });
  }

  changeTab(tabValue: DataGridTabModel) {
    if (tabValue.value != this.tab) {
      this.tab = tabValue.value;
      if (tabValue.booleanValue != undefined)
        this.booleanParam = tabValue.booleanValue;
      this.getData();
    }
  }

}

function compare(a: any, b: any, isAsc: any) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}


